import React, { useContext, useEffect, useState } from "react";
import "./styles.css"
import CloseIcon from '@mui/icons-material/Close';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import Context from "../../../../context/Context";

export const WagonTableCards = ({
  handleRemovePeca,
  isEdit,
  data,
  startMovePiece,
  startSwapPiece,
  confirmSwapPiece,
  movingPiece
}) => {
  const {
    selectedCountry,
    selectedWagon,
    confirmedWagon,
    wagon
  } = useContext(Context);

  const sourceKey = data.tipoCombinacaoPeca?.tipoComb_Key;
  const isSwapping = !!movingPiece && movingPiece.mode === 'swap';
  const isSwapSource = isSwapping && movingPiece.sourceTipoCombKey === sourceKey;

  const tableBody = (key, pecas, wagonData) => {


    const jsonItens = {
      ordem_Part_Short: pecas.ordem_Part_Short,
      subProduto_Desc: pecas.subProduto_Desc,
      ordem_Serial: pecas.ordem_Serial,
      ordem_VehCod: `${pecas.ordem_VehDesc} - ${pecas.ordem_VehCod}`,
      bomba_B: pecas.bomba_B,
      formulaCod: pecas.formulaCod,
      m2_Peca: (pecas.m2_Peca / 4.5).toFixed(3) ,
      mover: movePeca(pecas),
      trocar: trocarPeca(pecas),
      X: deletePeca(wagonData, pecas)
    };
    return jsonItens[key];
  };

  const itensWagon = [
    'ordem_Serial',
    'ordem_Part_Short',
    'subProduto_Desc',
    'bomba_B',
    'ordem_VehCod',
    'formulaCod',
    'm2_Peca',
    'mover',
    'trocar',
    "X"
  ];

  const deletePeca = (wagonData, pecas) => {
    return <CloseIcon
      className="closeButton"
      onClick={isEdit.isEdit ? () =>  handleRemovePeca(wagonData, pecas)  : () => { }}
    />
  }

  const movePeca = (pecas) => {
    if (isEdit.isEdit || !startMovePiece) return null;
    if (isSwapping) return null;
    return <ArrowRightAltIcon
      className="moveButton"
      style={{ cursor: 'pointer', color: '#1976d2' }}
      onClick={(e) => {
        e.stopPropagation();
        startMovePiece(pecas, sourceKey);
      }}
    />
  }

  const trocarPeca = (pecas) => {
    if (isEdit.isEdit || !startSwapPiece) return null;

    const isSourcePiece = isSwapSource && movingPiece.peca.ordem_Serial === pecas.ordem_Serial;
    const isPotentialTarget = isSwapping && !isSwapSource;

    if (isSourcePiece) {
      return <SwapHorizIcon
        style={{ color: '#ff9800', backgroundColor: '#fff3e0', borderRadius: '4px' }}
      />;
    }

    if (isPotentialTarget) {
      return <SwapHorizIcon
        style={{ cursor: 'pointer', color: '#fff', backgroundColor: '#4caf50', borderRadius: '4px' }}
        onClick={(e) => {
          e.stopPropagation();
          confirmSwapPiece(pecas, sourceKey);
        }}
      />;
    }

    if (isSwapping && isSwapSource) {
      return null;
    }

    return <SwapHorizIcon
      style={{ cursor: 'pointer', color: '#9c27b0' }}
      onClick={(e) => {
        e.stopPropagation();
        startSwapPiece(pecas, sourceKey);
      }}
    />;
  }

  return (
    <>
      {data.wagon.map((pecas, index) => (
        <tr key={index}>
          {itensWagon.map((item, subIndex) => (
            <td key={subIndex}>
              {tableBody(item, pecas, selectedWagon?.wagonInfo?.vagao_Key ? confirmedWagon : wagon)}
            </td>
          ))}
        </tr>
      ))}
    </>

  )
}